"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");




























































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      newadd: false, newadd2: false, urlNames: [], opesList: [], title: '', searchData: { insName: '', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, defaultData: { id: '', name: '', insName: '', enabled: '1', isForce: '0', firmwareDownloadType: '1', md5: '', path: '', urlList: [], remark: '', firmwareType: '3', url: '', url2: '', fileList: [] }, // 表格列
      tableColumns: [{ prop: 'insName', label: '公司名称', width: '180', isShow: true }] };}, mounted: function mounted() {var self = this;self.init();self.handleGetCompanyOps();}, methods: { init: function init() {var self = this;self.getData('/api/temi/company', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission,
    // 设置imageList
    setImageList: function setImageList(val) {
      var arr = [];
      if (val) {
        arr.push(val);
      }
      this.imageSrcList = arr;
    },
    resetFun: function resetFun() {// 重置
      this.searchData.insName = '';
      this.searchData.enabled = '';
      this.searchData.isForce = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      if (this.searchData.endTime) {
        var endTime = this.searchData.endTime;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.endTime = endTime;
        }
      }
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleGetCompanyOps: function handleGetCompanyOps() {
      var arr = [{ pathURL: '/robot/common/infos', name: '机器人' }, { pathURL: '/robot/introduce/homepage', name: '主页设置' },
      { pathURL: '/robot/introduce/propaganda', name: '宣传图片' }, { pathURL: '/robot/introduce/news', name: '集团新闻' },
      { pathURL: '/robot/introduce/introduction', name: '公司简介' }, { pathURL: '/robot/introduce/culture', name: '企业文化' },
      { pathURL: '/robot/introduce/story', name: '品牌故事' }, { pathURL: '/robot/quest/map', name: '地图管理' },
      { pathURL: '/robot/quest/task', name: '任务管理' },
      { pathURL: '/robot/quest/trigger', name: '触发事件' }, { pathURL: '/robot/common/employee', name: '通讯录' }];
      this.opesList = arr;
    },
    handleRouter2Page: function handleRouter2Page(pathURL, urlParams) {
      // pathURL = '../robotInfoList'
      this.$router.push({ path: pathURL, query: { orgId: urlParams } });
      // this.$route.push(pathURL)
    },
    addFun: function addFun() {// 新	增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm('确定移除 ${ file.name } ？');
    },
    onsuccess: function onsuccess(res) {
      this.getUrlNames();
    },
    UploadImage: function UploadImage(param) {// 上传文件
      var self = this;
      var formData = new FormData();
      formData.append('file', param.file);
      if (self.addData.path === '') {
        self.postFormData('/api/faOtaVersion/upload', formData, function (res) {
          console.log('res111', res);
          var url = res.url;
          self.addData.path = res.dir;
          self.addData.urlList.push(url);
          self.$message({
            message: '添加成功!',
            type: 'success' });

          param.onSuccess();
        });
      } else {
        formData.append('path', self.addData.path);
        self.postFormData('/api/faOtaVersion/upload', formData, function (res) {
          var url = res.url;
          self.addData.md5 = res.md5;
          self.addData.path = res.dir;
          self.addData.urlList.push(url);
          self.$message({
            message: '添加成功!',
            type: 'success' });

          param.onSuccess();
        });
      }
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        enabled: item.enabled + '',
        isForce: item.isForce + '',
        firmwareDownloadType: item.firmwareDownloadType + '',
        insName: item.insName,
        remark: item.remark,
        firmwareType: '3',
        md5: item.md5,
        url2: item.url,
        path: item.url };

      if (item.url) {
        self.addData.urlList = self.addData.url2.split(',');
      }
      self.getUrlNames();
      self.newadd = true;
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faOtaVersion', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faOtaVersion/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        enabled: '',
        isForce: '',
        firmwareDownloadType: '',
        insName: '',
        remark: '',
        firmwareType: '3',
        md5: '',
        url2: '',
        path: '' };

      this.urlNames = [];
    },
    openCopy: function openCopy(item) {
      var self = this;
      self.addData.url = item.url;
      self.newadd2 = true;
    },
    copyFun: function copyFun() {
      var url = document.querySelector('#copyObj');
      url.select(); // 选择对象
      document.execCommand('Copy');
      this.closeDiglog();
    },
    getUrlNames: function getUrlNames() {
      if (this.addData.urlList) {
        this.urlNames = [];
        for (var urlIndex in this.addData.urlList) {
          var myUrl = this.addData.urlList[urlIndex];
          var lastIndex = myUrl.lastIndexOf('/');
          this.urlNames.push(myUrl.substring(lastIndex + 1));
        }
      }
    } } };exports.default = _default;